jQuery.noConflict();
(function( $ ) {
    $(function() {
    //Document Ready STARTS

        var wdata = [];
        wdata.mobileWidth = 748;
        wdata.debug = false;

        //PLACEHOLDERS
        $('input, textarea').placeholder(); //add placeholders for load browsers
        svgSupport();
        singlePagerMenu();
        setTimeout(runOnce, 500);

        function runOnce() {
            windowParameters();
            $('.mobile-menu').hide();
            svgSupport();
            spacerHeight();
            runSliders();
            teamMemberImgHeight();
            mainSliderHeight();
            initParallax();

            if($('.isotope-item').length> 0) {
                setTimeout(function() {
                    initIsotope(); //isotope
                    checkOfrAnimation();
                },300);
            }

            $("[data-fancybox]").fancybox({
            });

            setTimeout(function() {
                spacerHeight();
            }, 500);

            setTimeout(function() {
                $(window).trigger('resize');
            }, 800);
        }

        //Functions On Window resize
        $( window ).resize(function() {
            windowParameters();
            teamMemberImgHeight();
            mainSliderHeight();
            setTimeout(function() {
                spacerHeight();
                $(window).trigger('resize.px.parallax');
            }, 300);
        });

        /* functions on window scroll */
        $(window).scroll(function() {
            wdata.scrollTop = $(window).scrollTop();

            if (wdata.scrollTop == 0) {
                setTimeout(function() {
                    spacerHeight();
                    setTimeout(function() {
                        spacerHeight();
                        $(window).trigger('resize.px.parallax');
                    }, 200);
                },300);
            }
            triggerHeaderClass();
            checkOfrAnimation();

        });

        function windowParameters() {
            var ww = getWindowWidth(),
                wh = getWindowHeight();
            wdata.scrollTop = $(window).scrollTop();
            wdata.ww = ww;
            wdata.hw = wh;
        }

        // mobile mnu toggle functions
        $('.hamburger').on('click', function(e){
            e.preventDefault();
            $(this).toggleClass('is-active');
            $('.mobile-menu').slideToggle().toggleClass('active');
        });

        $('.mobile-menu').hide();  //hide mobile menu when page loads

        //Adjust Header spacer height
        function spacerHeight() {
            var headerHeight = $('.header').outerHeight(),
                mobileMenuHeight = $('.mobile-menu').outerHeight(),
                mobileMenuStyle = $('.mobile-menu').attr('style');
            if (mobileMenuStyle == 'display: block;') {
                $('.header-spacer').height(headerHeight-mobileMenuHeight);
            }
            else {
                $('.header-spacer').height(headerHeight);
            }
        }


        $('.to-top').on('click', function(e) {
            e.preventDefault();
            scrollToEl('.content', 90);
        });

        function triggerHeaderClass() {
            var header = $('.header');
            if (wdata.scrollTop > 40) {
                header.addClass('hidden-top');
            }
            else {
                header.removeClass('hidden-top');
            }
            if (wdata.scrollTop > 300) {
                header.addClass('narrow-main');
            }
            else {
                header.removeClass('narrow-main');
            }
            //setTimeout(spacerHeight, 500);
        }

        function checkOfrAnimation() {
            $(".animate").each(function(i, el) {
                var el = $(el);
                if (el.visible(true)) {
                    el.addClass($(this).data('animation')).removeClass('animate').addClass('animated');
                    //console.log('ANIMATING '+$(this).data('animation'));
                }
            });
        }

        //Check if DOM has MAP
        if(($('#map').data('lat') != '') && ($('#map').data('lat') != undefined)) {
            initMap();
        }

        function showPop(html) {
            var target = $('#pop-modal'),
                targetContent = $('#pop-modal .content');
            targetContent.empty();
            targetContent.html(html);
            target.foundation('open');
        }

        $('a.play').on('click', function(e){
            e.preventDefault();
            var src = $(this).data('src');
            if (src != undefined && src != '') {
                if ($(this).hasClass('video')) {
                    var html = '<div class="flex-video"><video controls><source  src="'+src+'" type="video/mp4"></video></div>';
                }
                else {
                    var html = '<div class="flex-video"><iframe width="560" height="315" src="https://www.youtube.com/embed/'+src+'?autohide=1&showinfo=0&controls=1" frameborder="0" allowfullscreen></iframe> </div>'
                }
                showPop(html);
            }
        });

        $('#pop-modal .close-button').on('click', function() {
            $('#pop-modal .content').html('');
        });

        function mainSliderHeight() {
            var minHeight = 0,
                height = 620;
               // spacerHeight = $('.header-spacer').outerHeight(),
               // height = wdata.hw - (spacerHeight + 250);

            $.each($('.top-slide .center-wrap'), function(){
                var thisHeight = $(this).outerHeight();
                if (thisHeight > minHeight) {
                    minHeight = thisHeight;
                }
            });

            if (height < minHeight) {
                height = minHeight;
            }

            $.each($('.top-slide figure'), function(){
                var src = $(this).data('src'),
                    large = $(this).data('large');
                if (wdata.ww > 1366) {
                    $(this).attr('style', 'background: url('+large+') center top / cover no-repeat; height: '+height+'px;');
                }
                else {
                    $(this).attr('style', 'background: url('+src+') center top / cover no-repeat; height: '+height+'px;');
                }
            });
        }

        /* Run all flex sliders */
        function runSliders() {
            $('.imageslider').flexslider({
                animation: "slide"
            });

            $('.testimonials').flexslider({
                animation: "slide",
                directionNav: true,
                controlNav: false,
                prevText: "",
                nextText: "",
                animationLoop: true
            });

            $('.top-slider').flexslider({
                animation: "slide",
                directionNav: true,
                controlNav: true,
                prevText: "",
                nextText: "",
                animationLoop: true
            });

            if($('.logos-slider').length>0) {
                if($('body').hasClass('mobile')) {
                    $('.logos-slider').flexslider({
                        animation: "slide",
                        directionNav: false,
                        controlNav: false,
                        animationLoop: true
                    });
                }
                else {
                    /*                var ww = $('.logos-slider').width(),
                     slideW = (ww/ 5);*/
                    var sliderWidth = $('.logos-slider').width(),
                        slides = $('.logos-slider li').length,
                        slideWidth = sliderWidth / slides;
                    if (slideWidth< 150) {
                        slideWidth = 150;
                    }
                    $('.logos-slider').flexslider({
                        animation: "slide",
                        directionNav: true,
                        controlNav: false,
                        animationLoop: true,
                        prevText: "",
                        nextText: "",
                        itemWidth: slideWidth,
                        itemMargin: 0
                    });
                }
            }

            $(window).trigger('resize.px.parallax');
        }

        function singlePagerMenu() {

            $('a').on('click', function(e) {
                var url = $(this).attr('href');
                if (url != '' && url != undefined) {
                    var urlArr = url.split('#');
                    if (urlArr[1] != '' && urlArr[1] != undefined) {
                        smenu.find('li').removeClass('active');
                        if ($('#'+urlArr[1]).length>0) {
                            scrollToEl('#'+urlArr[1], 20);
                        }
                    }
                }
            });

            if ($('#menu-smenu').length>0) {
                var smenu = $('#menu-smenu');
                smenu.find('li').removeClass('active');

                $('#menu-smenu a').on('click', function() {
                    var url = $(this).attr('href'),
                        urlArr = url.split('#');
                    if (urlArr[1] != '' && urlArr[1] != undefined) {
                        smenu.find('li').removeClass('active');
                        if ($('#'+urlArr[1]).length>0) {
                            $(this).parent().addClass('active');
                        }
                    }
                });
            }

            $('.spage-wrap >div').on('mouseenter', function() {
                var newPageId = $(this).attr('id');
                $('#menu-smenu li').removeClass('active');
                if (newPageId == 'home') {
                    $('#menu-smenu li').addClass('active');
                }
                else {
                    $.each($('#menu-smenu li'), function() {
                        var url = $(this).find('a').attr('href'),
                            urlArr = url.split('#');
                        if (urlArr[1] == newPageId) {
                            $(this).addClass('active');
                        }
                    });
                }
            });
        }

        /* Setting member image height on medium and up*/
        function teamMemberImgHeight() {
            if ($('.tem-row').length>0) {
                $('.team-member figure').attr('style', '');
                if (wdata.ww > wdata.mobileWidth) {
                    var newHeight = $('.tem-row .team-member').width() * 0.65;
                    $.each($('.team-member figure'), function() {
                        var src = $(this).data('src');
                        $(this).attr('style', 'background: url('+src+') center center / cover no-repeat;').height(newHeight);
                    });
                    $(window).trigger('resize.px.parallax');
                }
            }
        }

        //Parallax for parallax objects
        function initParallax() {
            $('.parallax').each( function() {
                if($(this).data('src').length>0) {
                    $(this).parallax({imageSrc: $(this).data('src'), speed: 0.7});
                }
            });
        }

        //init MAP with custom settings
        function initMap() {

            var $mapDiv = $('#map'),
                lat = $mapDiv.data('lat'),
                lan = $mapDiv.data('lan'),
                zoom = $mapDiv.data('zoom'),
                marker = $mapDiv.data('marker'),
                title = $mapDiv.data('title'),
                windowHeight = $( window ).height(),
                mapHeight =  (windowHeight/2) - 150;

            //set map height to half window height
            if (mapHeight<400) {
                mapHeight = 400;
            }
            $mapDiv.height(mapHeight);

            if($('body').hasClass('mobile')) {
                var optionNavigationControl = false,
                    optionTypeControl = false,
                    optionScaleControl = false,
                    optionDraggable = false,
                    optionScrollwheel = false;
            }
            else {
                var optionNavigationControl = false,
                    optionTypeControl = true,
                    optionScaleControl = true,
                    optionDraggable = true,
                    optionScrollwheel = false;
            }

            var myLatLng = {lat: lat, lng: lan};
            var map = new google.maps.Map(document.getElementById('map'), {
                zoom: zoom,
                // mapTypeId: google.maps.MapTypeId.SATELLITE,
                navigationControl: optionNavigationControl,
                mapTypeControl: optionTypeControl,
                scaleControl: optionScaleControl,
                draggable: optionDraggable,
                scrollwheel: optionScrollwheel,
                center: myLatLng,
                styles: [
                    {
                        "elementType": "geometry",
                        "stylers": [
                            {
                                "color": "#2a2930"
                            }
                        ]
                    },
                    {
                        "elementType": "labels.text.fill",
                        "stylers": [
                            {
                                "color": "#cca34b"
                            }
                        ]
                    },
                    {
                        "elementType": "labels.text.stroke",
                        "stylers": [
                            {
                                "color": "#14212b"
                            }
                        ]
                    },
                    {
                        "featureType": "administrative.locality",
                        "elementType": "geometry",
                        "stylers": [
                            {
                                "color": "#000060"
                            }
                        ]
                    },
                    {
                        "featureType": "administrative.locality",
                        "elementType": "labels.text.fill",
                        "stylers": [
                            {
                                "color": "#d59563"
                            }
                        ]
                    },
                    {
                        "featureType": "poi",
                        "elementType": "labels.text.fill",
                        "stylers": [
                            {
                                "color": "#d59563"
                            }
                        ]
                    },
                    {
                        "featureType": "poi.park",
                        "elementType": "geometry",
                        "stylers": [
                            {
                                "color": "#424242"
                            }
                        ]
                    },
                    {
                        "featureType": "poi.park",
                        "elementType": "labels.text.fill",
                        "stylers": [
                            {
                                "color": "#6b9a76"
                            }
                        ]
                    },
                    {
                        "featureType": "road",
                        "elementType": "geometry",
                        "stylers": [
                            {
                                "color": "#38414e"
                            }
                        ]
                    },
                    {
                        "featureType": "road",
                        "elementType": "geometry.stroke",
                        "stylers": [
                            {
                                "color": "#212a37"
                            }
                        ]
                    },
                    {
                        "featureType": "road",
                        "elementType": "labels.text.fill",
                        "stylers": [
                            {
                                "color": "#9ca5b3"
                            }
                        ]
                    },
                    {
                        "featureType": "road.highway",
                        "elementType": "geometry",
                        "stylers": [
                            {
                                "color": "#cca24b"
                            }
                        ]
                    },
                    {
                        "featureType": "road.highway",
                        "elementType": "geometry.stroke",
                        "stylers": [
                            {
                                "color": "#1f2835"
                            }
                        ]
                    },
                    {
                        "featureType": "road.highway",
                        "elementType": "labels.text.fill",
                        "stylers": [
                            {
                                "color": "#f3d19c"
                            }
                        ]
                    },
                    {
                        "featureType": "transit",
                        "elementType": "geometry",
                        "stylers": [
                            {
                                "color": "#2f3948"
                            }
                        ]
                    },
                    {
                        "featureType": "transit.station",
                        "elementType": "labels.text.fill",
                        "stylers": [
                            {
                                "color": "#d59563"
                            }
                        ]
                    },
                    {
                        "featureType": "water",
                        "elementType": "geometry",
                        "stylers": [
                            {
                                "color": "#15222c"
                            }
                        ]
                    },
                    {
                        "featureType": "water",
                        "elementType": "labels.text.fill",
                        "stylers": [
                            {
                                "color": "#515c6d"
                            }
                        ]
                    },
                    {
                        "featureType": "water",
                        "elementType": "labels.text.stroke",
                        "stylers": [
                            {
                                "color": "#17263c"
                            }
                        ]
                    }
                ]
            });

            var markerImage = new google.maps.MarkerImage(marker,
                new google.maps.Size(60, 60), //size
                new google.maps.Point(0, 0), //origin point
                new google.maps.Point(30, 60)); // offset point

            var marker = new google.maps.Marker({
                position: myLatLng,
                map: map,
                icon: markerImage,
                title: title
            });

            if ($('.markers-list').length>0) {
                $.each($('.markers-list li'), function() {
                    var lat = $(this).data('lat'),
                        lan = $(this).data('lan'),
                        newTitle = $(this).data('title'),
                        newLatLng = {lat: lat, lng: lan};

                    console.info(newTitle);
                    console.log(newLatLng);

                    var marker = new google.maps.Marker({
                        position: newLatLng,
                        map: map,
                        icon: markerImage,
                        title: newTitle
                    });
                });
            }
        }
        /**
         * Isotope for tem mmebers filtering
         */
        function initIsotope() {

            var defaultOptions = {
                filter: "*",
                itemSelector: '.isotope-item',
                layoutMode: 'masonry'
            };

            var $container = $('.isotope').isotope(defaultOptions);

            // filter functions
            var filterFns = {
                // show if number is greater than 50
                numberGreaterThan50: function() {
                    var number = $(this).find('.number').text();
                    return parseInt( number, 10 ) > 50;
                },
                // show if name ends with -ium
                ium: function() {
                    var name = $(this).find('.name').text();
                    return name.match( /ium$/ );
                }
            };

            var filterString = $('.isotope').data('filter');
            if (filterString != '' && filterString != undefined) {
                // console.log('FILTER: '+filterString);
                filterValue = '.'+filterString;
                filterValue = filterFns[ filterValue ] || filterValue;
                $container.isotope({ filter: filterValue });
            }

            $('.filter li').on( 'click', function(e) {
                e.preventDefault();
                $('.filter li').removeClass('active');
                $(this).addClass('active');
                var filterValue = $(this).data('sel');
                if (filterValue != '') {
                    var filterString = filterValue;
                    filterValue = '.'+filterValue;
                }
                // use filterFn if matches value
                $container.isotope({ filter: filterValue });
            });

            var filterValue = '.show-first'
            $container.isotope({ filter: filterValue });
        }

        //click trigger
        function bindClick() {
            $('.clickTrigger').on('click', function(e) {
                e.preventDefault();
                var targetLine = $(this).data('target');
                var $target = $( targetLine);
                $target.trigger( "click" );

            });
        }

        //Scroll to el if page has Hash
        if(window.location.hash) {
            var hash = window.location.hash;
            if ($(hash).length>0) {
                setTimeout(function(){
                    scrollToEl(hash, 220);
                }, 1200);

            }
        }

        //function scroll to element
        function scrollToEl(target, offset) {
            var $target = $(target);
            $("html, body").animate({ scrollTop: $target.offset().top - (offset + 70)}, 1000);
        }

        //window height
        function getWindowHeight() {
            return $( window ).height();
        }

        //window width
        function getWindowWidth() {
            return $( window ).width();
        }

        //validate Phone
        function validatePhone(phone) {
            var re = /^((\+[1-9]{1,4}[ \-]*)|(\([0-9]{2,3}\)[ \-]*)|([0-9]{2,4})[ \-]*)*?[0-9]{3,4}?[ \-]*[0-9]{3,4}?$/;
            return re.test(phone);
        }

        //validate Email
        function validateEmail(email) {
            var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
            return re.test(email);
        }

        //check if element is visible #element, .element
        function isElementVisible(elementToBeChecked) {
            var TopView = $(window).scrollTop();
            var BotView = TopView + $(window).height();
            var TopElement = $(elementToBeChecked).offset().top;
            var BotElement = TopElement + $(elementToBeChecked).height();
            return ((BotElement <= BotView) && (TopElement >= TopView));
        }

        function svgSupport() {
            if (typeof SVGRect != "undefined") {
                $('body').addClass('svg');
                var status = true;
            }
            else {
                $('body').addClass('no-svg');
                var status = false;
            }
            return status;
        }

    //Document Ready ENDS
    });
})(jQuery);